<template>
  <div class="alarm-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="form.type"
            placeholder="请选择"
            style="width: 160px; display: inline-block"
            @change="onChangeStripe()"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.alarm_type"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="form.value"
            placeholder="请输入车牌号"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-date-picker
            style="margin-left: 8px"
            v-model="form.startDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker
          >-
          <el-date-picker
            v-model="form.endDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        v-loading="loading"
        :data="table.data"
        :height="table.height"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="alarm_num"
          label="车架号"
          show-overflow-tooltip
          width="260"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="license_num" label="车牌号" align="center">
        </el-table-column>
        <el-table-column
          prop="alarm_time"
          label="报警时间"
          width="150"
          align="center"
        >
        </el-table-column>
        <el-table-column label="报警类型" align="center">
          <template slot-scope="{ row }">
            <div class="alarm_code">
              <!-- <span v-show="row.alarm_code == 1"><i class="iconfont icon-yanwu"></i>烟雾</span>
              <span v-show="row.alarm_code == 2"><i class="iconfont icon-ranqi"></i>燃气</span>
              <span v-show="row.alarm_code == 3"><i class="iconfont icon-crash-c"></i>碰撞</span>
              <span v-show="row.alarm_code == 4"><i class="iconfont icon-icon-co"></i>CO</span>
              <span v-show="row.alarm_code == 5"><i class="iconfont icon-fanchebaojing"></i>翻车</span> -->
              <span>{{ row.alarm_type }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <span class="status" v-show="row.status == 0">已忽略</span>
            <span class="status" v-show="row.status == 1">已处理</span>
            <span class="status red" v-show="row.status == 2">待处理</span>
          </template>
        </el-table-column>
        <el-table-column prop="alarm" label="报警内容" align="center">
        </el-table-column>
        <el-table-column label="操作" width="170" align="center">
          <template slot-scope="scope">
            <div class="edit" v-if="scope.row.status == 2">
              <span
                class="btn read"
                @click="neglectClick(scope.row.id)"
                v-hasPermi="['报警信息管理', '忽略']"
                >忽略</span
              >
              <span
                class="btn read"
                @click="confirmClick(scope.row.id)"
                v-hasPermi="['报警信息管理', '已确认']"
                >已确认</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { GetAlarmList, GetTypeList, UpdateStatus } from '@/api/alarm'
import { MessageBox } from 'element-ui'
export default {
  data () {
    return {
      form: {
        value: '',
        type: ''
      },
      options: [
        { alarm_type: '全部', id: 0 }
      ],
      loading: false,
      table: {
        data: [
          // { id: 1, number: 'tx20190919', datetime: '2019-12-02 13:02', type: 1, status: 1, desc: '烟雾报警' },
          // { id: 1, number: 'tx20190918', datetime: '2019-12-02 03:12', type: 2, status: 1, desc: '燃气报警' },
          // { id: 1, number: 'tx20190917', datetime: '2019-12-01 08:11', type: 3, status: 2, desc: '碰撞报警' },
          // { id: 1, number: 'tx20190916', datetime: '2019-12-01 04:02', type: 4, status: 2, desc: 'CO报警' },
          // { id: 1, number: 'tx20190916', datetime: '2019-12-01 04:02', type: 5, status: 2, desc: '翻车报警' },
        ],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      }
    }
  },
  created () {
    this.getSortData()
    this.getData()
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
  },
  methods: {
    onChangeStripe () {
      this.search()
    },
    getSortData () {
      GetTypeList()
        .then(res => {
          this.options = this.options.concat(res.data)
        })
    },
    getData () {
      this.loading = true
      const params = { start: this.table.currentPage, size: this.table.size }
      this.form.type ? params.alarm_type = this.form.type : ''
      this.form.value ? params.alarm_num = this.form.value : ''
      this.form.startDate ? params.startDate = this.form.startDate : ''
      this.form.endDate ? params.endDate = this.form.endDate : ''
      GetAlarmList(params).then(res => {
        this.loading = false;
        if (res.code == 0) {
          const data = res.data
          this.table.data = data.content
          this.table.total = data.total
        } else {
          this.$message.error(res.message);
        }
        this.$refs.tables.bodyWrapper.scrollTop = 0;

      })
    },
    search () {
      this.currentPage = 1
      this.getData()
    },
    //忽略
    neglectClick (id) {
      const data = {
        id: id,
        status: 0
      }
      MessageBox.confirm('确认忽略?', '提示', {
        confirmButtonText: '确定',
        concelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        UpdateStatus(data).then(res => {
          if (res.code == 0) {
            this.$message.success("操作成功")
            this.search()
          }
        })
      }).catch(() => { })
    },
    //已确认
    confirmClick (id) {
      const data = {
        id: id,
        status: 1
      }
      MessageBox.confirm('确认?', '提示', {
        confirmButtonText: '确定',
        concelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        UpdateStatus(data).then(res => {
          if (res.code == 0) {
            this.$message.success("操作成功")
            this.search()
          }
        })
      }).catch(() => { })
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.getData()
    },
  },
  filters: {
    status_f (val) {
      let res = ''
      switch (val) {
        case 0:
          res = '离线'
          break;
        case 1:
          res = '在线'
          break;
      }
      return res
    }
  }
}
</script>

<style lang="less" scoped>
.alarm-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .type {
      .iconfont {
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #f00;
      }
    }
    .status {
      &.red {
        color: #f00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.alarm-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
